import { IUser } from '@/interfaces/entities/user';
import { AccountStatus } from '@/interfaces/entities/user.account-status';

export const accountStatusColor = (user: IUser) => {
	switch (user.applicationRequest) {
		case AccountStatus.Accepted:
			return 'text-green-500';
		case AccountStatus.Rejected:
			return 'text-red-500';
		case AccountStatus.Pending:
			return 'text-yellow-500';
	}
};
